module.exports = __webpack_public_path__ + "static/media/tiktok-icon-newpurple.d9219796.svg";